import { forwardRef, type Ref, type SVGProps } from "react";

function SvgExtraPay(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3 5h.667m8.666 6H13M1 11V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2m9-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgExtraPay);
export default ForwardRef;
